import React from "react";
import { Phone, ShieldCheck, Star, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/lib/api";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative overflow-hidden cg-pink-bg"
      data-testid="hero-section"
    >
      {/* Halftone background pattern */}
      <div className="absolute inset-0 cg-halftone-light opacity-70 pointer-events-none" />
      {/* Large coral circle accent */}
      <div className="absolute -top-32 -right-32 w-[560px] h-[560px] rounded-full bg-[#E50914] opacity-10 pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#E50914] opacity-[0.07] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left content */}
        <div className="cg-fade-up" data-testid="hero-content">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-[#FCE7E9] mb-6">
            <ShieldCheck className="w-4 h-4 text-[#E50914]" />
            <span className="text-sm font-semibold text-[#0F0F0F]">
              20+ Years Serving the Lower Mainland
            </span>
          </div>

          <h1 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
            BC's Trusted HVAC,{" "}
            <span className="text-[#E50914]">Heating & Gas</span> Fitting Experts
          </h1>

          <p className="text-lg text-[#475569] max-w-xl mb-8 leading-relaxed">
            From emergency furnace repairs to whole-home heat pump installs, our Red Seal-certified team keeps your home comfortable, efficient, and safe all year round.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 mb-10">
            <a href="#contact" className="btn-coral" data-testid="hero-cta-quote">
              Get a Free Quote
              <ArrowRight className="w-4 h-4" />
            </a>
            <a href={BUSINESS.phoneHref} className="btn-outline-coral" data-testid="hero-cta-call">
              <Phone className="w-4 h-4" />
              {BUSINESS.phone}
            </a>
          </div>

          {/* Trust strip */}
          <div className="flex flex-wrap gap-6 items-center text-sm">
            <div className="hidden sm:flex items-center gap-2 text-[#0F0F0F] font-medium">
              <ShieldCheck className="w-4 h-4 text-[#E50914]" />
              Licensed Gas Fitters &amp; Red Seal HVAC
            </div>
          </div>
        </div>

        {/* Right visual */}
        <div className="relative cg-fade-up" data-testid="hero-visual">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/img/hero/truck.webp"
              alt="Corona Gas HVAC service vehicle on a job"
              className="w-full h-[460px] object-cover"
            />
            {/* Coral overlay strip */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0F0F0F]/85 via-[#0F0F0F]/40 to-transparent p-6">
              <div className="text-white">
                <div className="text-xs uppercase tracking-widest opacity-80 mb-1">
                  Serving BC for 20+ years
                </div>
                <div className="text-2xl font-[Manrope] font-bold">
                  Comfort, safety and efficiency, done right.
                </div>
              </div>
            </div>
          </div>

          {/* Floating callout */}
          <div className="absolute -bottom-8 -left-4 sm:left-6 bg-white rounded-2xl shadow-xl p-5 max-w-[280px] border border-[#FCE7E9]" data-testid="hero-callout">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-full bg-[#E50914] flex items-center justify-center">
                <ShieldCheck className="w-5 h-5 text-white" />
              </div>
              <div className="font-[Manrope] font-bold text-[#0F0F0F]">
                CleanBC Rebates
              </div>
            </div>
            <div className="text-sm text-[#475569] leading-snug">
              Rebates available on qualifying heat pump upgrades. We help you with the paperwork, though final submission stays with you.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
